import { Heart, Users, Award } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1676478966447-b3ca3565d3ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxncmFuZHBhcmVudHMlMjB3aXRoJTIwZ3JhbmRjaGlsZHJlbnxlbnwwfHx8fDE3Nzg3MTAyNTd8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28 bg-ivory" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="aspect-[4/5] sm:aspect-square overflow-hidden rounded-xl border border-border shadow-xl">
              <img src={ABOUT_IMG} alt="Family enjoying time together" className="w-full h-full object-cover" />
            </div>
          </div>
          <div>
            <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-gold-deep font-semibold">About Us</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight mt-3">
              A Legacy Built On Compassion, Security &amp; Trust.
            </h2>
            <div className="accent-line mt-5" />
            <p className="mt-6 text-navy/80 text-base sm:text-lg leading-relaxed">
              Legacy Security Life is a family-first agency specializing in <strong>final expense life insurance</strong> for
              seniors and their loved ones. We believe no family should have to worry about funeral costs, medical bills, or
              unpaid debts during a time of grief. Our licensed agents take the time to listen, explain options in plain
              language, and find a policy that fits your budget.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-6">
              <div data-testid="about-stat-clients" className="rounded-lg border border-border bg-white p-5 lift-on-hover">
                <Users className="h-6 w-6 text-[#C5A059]" />
                <p className="font-serif text-3xl text-navy mt-3">10,000+</p>
                <p className="text-sm text-muted-foreground mt-1">Families Protected</p>
              </div>
              <div data-testid="about-stat-experience" className="rounded-lg border border-border bg-white p-5 lift-on-hover">
                <Award className="h-6 w-6 text-[#C5A059]" />
                <p className="font-serif text-3xl text-navy mt-3">A+ Rated</p>
                <p className="text-sm text-muted-foreground mt-1">Top-tier carriers only</p>
              </div>
              <div data-testid="about-stat-heart" className="rounded-lg border border-border bg-white p-5 lift-on-hover">
                <Heart className="h-6 w-6 text-[#C5A059]" />
                <p className="font-serif text-3xl text-navy mt-3">100%</p>
                <p className="text-sm text-muted-foreground mt-1">No-Pressure Promise</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
